import PageWrapper, {
  XsmPageWrapperStyles,
  SmPageWrapperStyles,
  MdPageWrapperStyles,
  LgPageWrapperStyles,
  XlgPageWrapperStyles,
  PageWrapperStyles,
  FixedWidthPageStyles,
  FixedWidthPageWrapper,
} from './PageWrapper';

export {
  XsmPageWrapperStyles,
  SmPageWrapperStyles,
  MdPageWrapperStyles,
  LgPageWrapperStyles,
  XlgPageWrapperStyles,
  PageWrapperStyles,
  FixedWidthPageStyles,
  FixedWidthPageWrapper,
};

export default PageWrapper;
